import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Blog from '@/components/Blog'
import Articulo from '@/components/Articulo'
import '../assets/slick/slick-theme.css'
import '../assets/css/elegant.css'
import '../assets/css/custom_bootstrap.css'
import '../assets/css/plyr.min.css'
import '../assets/css/blog.css'

Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  } else {
    const position = {}

    if (to.hash) {
      position.selector = to.hash

      // if (to.hash === '#modulos') {
      //   position.offset = { y: 50 }
      // }

      if (document.querySelector(to.hash)) {
        return position
      }

      return false
    }

    return { x: 0, y: 0 }
  }
}

export default new Router({
  scrollBehavior,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { scrollToTop: true }
    },
    {
      path: '/Blog',
      name: 'Blog',
      component: Blog,
      meta: { scrollToTop: true }
    },
    {
      path: '/Articulo/:id',
      name: 'Articulo',
      component: Articulo,
      meta: { scrollToTop: true }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js